/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Typography, Button, Row, Col, Breadcrumb, Tooltip, Modal, Spin, Space, Select } from 'antd';
import * as AntDIcons from '@ant-design/icons';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
// import { useDispatch } from 'react-redux';
import Create from './Components/Create';
// import Edit from './Components/Edit';

const { Text } = Typography;
const { Option } = Select;

export function ProjectSubjects() {
   const navigate = useNavigate();
   // const dispatch = useDispatch();

   // const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const user_full_name = Utils.getCurrentUserInfo(Enums.UserInfo.fullname);

   const [user_id, setUserId] = useState(Utils.getCurrentUserInfo(Enums.UserInfo.id));
   const [userList, setUserList] = useState([]);
   const [creating, setCreating] = useState(false);
   // const [updating, setUpdating] = useState(false);

   // const [homeworkID, setHomeoworkID] = useState("");
   // const [homeworkData, setHomeworkData] = useState(null);

   const [subjectList, setSubjectList] = useState([]);
   // const [subjectName, setSubjectName] = useState(null);
   const [createModalVisible, setCreateModalVisible] = useState(false);
   // const [editModalVisible, setEditModalVisible] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      if (user_role.toLowerCase() === "admin") {
         var url = `${process.env.REACT_APP_API_LESSON}/listAllStaff`;
         axios.get(url).then((response) => {
            if (response.data) {
               let data = response.data;
               var users = data.filter((d) => d.id !== Number(user_id)).sort((a, b) => {
                  var aVal = a["first_Name"];
                  var bVal = b["first_Name"];
                  switch (typeof aVal) {
                     case 'string':
                        return aVal.localeCompare(bVal);
                     case 'number':
                        return aVal - bVal;
                     default:
                        throw new Error("Unsupported value to sort by");
                  }
               });
               var final = data.filter((d) => d.id === Number(user_id));
               Array.prototype.push.apply(final, users);
               setUserList(final)
            }
         }, (error) => {
            // setLoading(false);
            console.log(error.message);
         });
      }


      if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
         navigate('/home');

      // localStorage.removeItem('mastery-assessment-search-keys');
      getSubjects(user_id);

   }, []);

   const getSubjects = (userid) => {
      axios.get(`${process.env.REACT_APP_API_HOMEWORK}/subjectgroup?id=${userid}&t=project`).then((response) => {
         if (response.data) {
            const data = response.data;
            var subjects = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               subjects.push(obj);
            });

            setSubjectList(subjects);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   // function colorize() {
   //    var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   //    return '#' + r + g + b;
   // }

   const handleCreateProject = () => {
      setCreateModalVisible(true)
   }

   const handleCancelCreate = () => {
      setCreateModalVisible(false);
   }

   const handleOnFinishCreate = (homeworkData, fileForUpload) => {
      setCreating(true);

      if (fileForUpload.length > 0) {
         var formData = new FormData();

         fileForUpload.forEach(file => {
            // the name has to be 'files' so that .NET could properly bind it (Phuck this sheet! Took me the whole day to find this sheet!)
            formData.append('files', file);
         });

         var uploadedfiles = "";
         var url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}`;
         axios.post(url, formData).then(response => {

            if (response.data) {
               uploadedfiles = response.data;

               homeworkData.document = uploadedfiles;

               var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
               axios.post(url, homeworkData).then(response => {
                  setCreating(false);
                  if (response.data) {
                     Modal.success({
                        title: 'Project',
                        content: 'Project created.',
                        centered: true,
                        onOk: () => { setCreateModalVisible(false) },
                     });

                     getSubjects();
                  }
               }, (error) => {
                  setCreating(false);
                  Modal.error({
                     title: 'Project',
                     content: error.response.data,
                     centered: true,
                     onOk: () => { setCreateModalVisible(false) },
                  });
               });

            }
         }, (error) => {
            // console.log(error.message);
         });
      } else {
         var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
         axios.post(url, homeworkData).then(response => {
            setCreating(false);
            if (response.data) {
               Modal.success({
                  title: 'Project',
                  content: 'Project created.',
                  centered: true,
                  onOk: () => { setCreateModalVisible(false) },
               });

               getSubjects();
            }

         }, (error) => {
            setCreating(false);
            Modal.error({
               title: 'Project',
               content: error.response.data,
               centered: true,
               onOk: () => { setCreateModalVisible(false) },
            });
         });
      }
   }

   const itemSubjectClick = (subject, subjectname) => {
      navigate(`/projects?id=${subject}&name=${subjectname}&staff=${user_id}`);
   }

   const handleUserChange = (id) => {
      setUserId(id);
      getSubjects(id);
   }

   return (
      <>
         <NoticeBoardSlide />
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <Breadcrumb separator=">" style={{ paddingBottom: '15px' }}>
                     <Breadcrumb.Item>
                        <Link to="/home">Home</Link>
                     </Breadcrumb.Item>
                     <Breadcrumb.Item>Brainee LMS</Breadcrumb.Item>
                     <Breadcrumb.Item>Project Subjects</Breadcrumb.Item>
                  </Breadcrumb>
               </div>

               {
                  <Row gutter={12} style={{ paddingBottom: "15px" }}>
                     <Col className="gutter-row" span={12} style={{ textAlign: "left" }}>
                        <div className='search-columns-2'>
                           {user_role.toLowerCase() === 'admin' &&
                              <>
                                 <Space direction='horizontal' size={'small'}>
                                    <span>View as </span>
                                    <Select
                                       showSearch
                                       placeholder="Search to Select"
                                       optionFilterProp="children"
                                       filterOption={(input, option) => option.children.includes(input)}
                                       defaultValue={user_full_name} style={{ width: '250px' }} onChange={(value) => handleUserChange(value)} >
                                       {
                                          userList.map((item) => {
                                             var fullname = (item.first_Name + " " + item.last_Name).trimEnd()
                                             return (
                                                <Option value={item.id}>{fullname}</Option>
                                             )
                                          })
                                       }
                                    </Select>
                                 </Space>
                              </>
                           }

                           {/* <Tooltip placement="bottom" title='Create new Homework'>
                              <Button className='button-shadow' type='primary' size='large' shape='round' style={{ maxWidth: '25ch' }} onClick={() => handleCreateHomework()}>
                                 <Text ellipsis style={{ color: "#fff" }}><AntDIcons.PlusOutlined />&nbsp;Create Homework</Text>
                              </Button>
                           </Tooltip> */}
                        </div>
                     </Col>
                     <Col className="gutter-row" span={12} style={{ textAlign: "right" }}>
                        <Tooltip placement="bottom" title='Create new Project'>
                           <Button className='button-shadow' type='primary' size='large' shape='round' style={{ maxWidth: '25ch' }} onClick={() => handleCreateProject()}>
                              <Text ellipsis style={{ color: "#fff" }}><AntDIcons.PlusOutlined />&nbsp;Create Project</Text>
                           </Button>
                        </Tooltip>
                     </Col>
                  </Row>
               }

               <div className="ag-format-container">
                  <div className="ag-courses_box">
                     {
                        // !questionTypeModalVisible &&
                        subjectList.map((subject, i) => {
                           var color = Utils.colorize();

                           return (
                              <>
                                 <div className="ag-courses_item">
                                    <a href="#" className="ag-courses-item_link">
                                       <div className="ag-courses-item_bg" style={{ backgroundColor: color }} onClick={() => itemSubjectClick(subject.value, subject.name)}></div>
                                       <div className="ag-courses-item_title" onClick={() => itemSubjectClick(subject.value, subject.name)}>
                                          {subject.name}
                                       </div>
                                    </a>
                                 </div>
                              </>
                           )
                        })
                     }
                  </div>
               </div>
            </div>
         </div>

         <Modal
            title={"Create Project"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelCreate(); }}
            open={createModalVisible}
            // width={window.innerWidth - 400}
            width='80%'
            // footer={null}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
         >
            <Spin spinning={creating} tip="Creating project, please wait...">
               <Create
                  onCancelCallback={handleCancelCreate}
                  onFinishCallback={handleOnFinishCreate}
                  type='project'
               />
            </Spin>
         </Modal>

         {/* <Modal
            title={"Edit Project"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelEdit(); }}
            open={editModalVisible}
            // width={window.innerWidth - 400}
            width='80%'
            // footer={null}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
         >
            <Spin spinning={updating} tip={"Updating, please wait..."}>
               <Edit
                  homeworkID={homeworkID}
                  homeworkData={homeworkData}
                  onCancelCallback={handleCancelEdit}
                  onFinishCallback={handleOnFinishEdit}
                  type='project'
               />
            </Spin>
         </Modal> */}
      </>
   )
}